import { ExportStatus } from '@/models/report'
import * as SalesAccountingModel from '@/models/sales-manager/sales-accounting'

/** 売上管理の出力履歴から出力するファイルの種類（backend の SalesExportType） */
export const SalesExportType = {
  SalesDetail: 'salesDetail',
  PaymentList: 'paymentList',
  DailyClosing: 'dailyClosing',
  MonthlyClosing: 'monthlyClosing',
  Accounting: 'accounting',
} as const
export type SalesExportType = (typeof SalesExportType)[keyof typeof SalesExportType]

export type SalesExportFormat = 'csv' | 'pdf'

/** GET /sales-manager/sales-exports の 1 件 */
export type SalesExportHistory = {
  id: number
  createdAt: string | null
  type: SalesExportType
  format: SalesExportFormat
  period: string
  status: ExportStatus
  /** 完了したときだけ返る期限付きのダウンロード URL */
  url: string | null
}

/** 売上明細の検索・出力の条件（期間は unixtime。未指定は 0）と絞り込み */
export type SalesDetailSearchParams = { beginDate: number; endDate: number } & Record<string, string | number>

/** POST /sales-manager/sales-exports の本文。種類ごとに必要な条件が違う */
export type SalesExportRequest =
  | ({ type: typeof SalesExportType.SalesDetail; format: 'csv' } & SalesDetailSearchParams)
  | {
      type: typeof SalesExportType.PaymentList
      format: 'csv'
      /** 締めの営業日（YYYY-MM-DD）。入金期間は backend が締めから求める */
      from: string
      to: string
    }
  | { type: typeof SalesExportType.DailyClosing; format: SalesExportFormat; date: string }
  | { type: typeof SalesExportType.MonthlyClosing; format: SalesExportFormat; month: string }
  | {
      type: typeof SalesExportType.Accounting
      format: 'csv'
      from: string
      to: string
      systemType: SalesAccountingModel.SystemType
      formatType: SalesAccountingModel.FormatType
      dateRangeType: SalesAccountingModel.DateRangeType
    }

/** 出力履歴に表示する種類の名前（i18n キー） */
export const salesExportTypeLabelKey: Record<SalesExportType, string> = {
  [SalesExportType.SalesDetail]: 'SalesExport.Type.salesDetail',
  [SalesExportType.PaymentList]: 'SalesExport.Type.paymentList',
  [SalesExportType.DailyClosing]: 'SalesExport.Type.dailyClosing',
  [SalesExportType.MonthlyClosing]: 'SalesExport.Type.monthlyClosing',
  [SalesExportType.Accounting]: 'SalesExport.Type.accounting',
}
